
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warrantyfor.house/privacy-policy",
      function () {
        return require("private-next-pages/warrantyfor.house/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warrantyfor.house/privacy-policy"])
      });
    }
  